var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitcoinFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12237_127004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "url(#paint0_linear_12237_127004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 20.4873L1.5 22.7686C1.85 23.5123 2.25 24.2248 2.7 24.8998L4.8625 22.7373C4.4375 22.0248 4.06875 21.2748 3.78125 20.4873Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7687 1.5L20.4875 3.78125C21.275 4.06875 22.0312 4.43125 22.7375 4.8625L24.9 2.7C24.225 2.25 23.5125 1.84375 22.7687 1.5Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33125 24.7129L4.21875 26.8254C4.59375 27.2316 4.99375 27.6254 5.40625 27.9941L7.525 25.8754C7.10625 25.5129 6.70625 25.1254 6.33125 24.7129Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.825 4.21875L24.7125 6.33125C25.125 6.70625 25.5125 7.1 25.875 7.525L27.9938 5.40625C27.625 4.99375 27.2313 4.59375 26.825 4.21875Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35626 30.0561C8.64376 30.2123 8.93751 30.3623 9.23126 30.4998L11.5125 28.2186C11.1938 28.0998 10.8813 27.9748 10.5813 27.8311L8.35626 30.0561Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0562 8.35645L27.8312 10.5814C27.9687 10.8877 28.1 11.1939 28.2187 11.5127L30.5 9.23145C30.3625 8.93145 30.2125 8.64395 30.0562 8.35645Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 29.0123C23.1866 29.0123 29.0125 23.1864 29.0125 15.9998C29.0125 8.8132 23.1866 2.9873 16 2.9873C8.81338 2.9873 2.98749 8.8132 2.98749 15.9998C2.98749 23.1864 8.81338 29.0123 16 29.0123Z",
    fill: "url(#paint1_linear_12237_127004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2.9873C8.81249 2.9873 2.98749 8.8123 2.98749 15.9998C2.98749 19.8498 4.66249 23.3123 7.31874 25.6936C5.24999 23.3873 3.99374 20.3436 3.99374 17.0061C3.99374 9.81855 9.81874 3.99355 17.0062 3.99355C20.3437 3.99355 23.3875 5.2498 25.6937 7.31855C23.3125 4.6623 19.85 2.9873 16 2.9873Z",
    fill: "#F27E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3812 17.1254C22.2687 16.4379 22.8375 15.3691 22.8375 14.1629C22.8375 12.1004 21.1562 10.4191 19.0937 10.4191H18.1937V9.15039C18.1937 8.71914 17.8437 8.36914 17.4125 8.36914C16.9812 8.36914 16.6312 8.71914 16.6312 9.15039V10.4191H14.4V9.15039C14.4 8.71914 14.05 8.36914 13.6187 8.36914C13.1875 8.36914 12.8375 8.71914 12.8375 9.15039V10.4191H11.5687C11.1375 10.4191 10.7875 10.7691 10.7875 11.2004C10.7875 11.6316 11.1375 11.9816 11.5687 11.9816H12.8375V17.1254V22.2691H11.5687C11.1375 22.2691 10.7875 22.6191 10.7875 23.0504C10.7875 23.4816 11.1375 23.8316 11.5687 23.8316H12.8375V25.1004C12.8375 25.5316 13.1875 25.8816 13.6187 25.8816C14.05 25.8816 14.4 25.5316 14.4 25.1004V23.8316H16.6312V25.1004C16.6312 25.5316 16.9812 25.8816 17.4125 25.8816C17.8437 25.8816 18.1937 25.5316 18.1937 25.1004V23.8316H19.0937C21.1562 23.8316 22.8375 22.1504 22.8375 20.0879C22.8375 18.8816 22.2625 17.8129 21.3812 17.1254ZM21.275 14.1629C21.275 15.3629 20.3 16.3441 19.0937 16.3441H14.3937V11.9816H19.0937C20.3 11.9816 21.275 12.9629 21.275 14.1629ZM19.0937 22.2691H14.3937V17.9066H19.0937C20.2937 17.9066 21.275 18.8816 21.275 20.0879C21.275 21.2941 20.3 22.2691 19.0937 22.2691Z",
    fill: "#F27E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5687 16.0004C21.4562 15.3129 22.025 14.2441 22.025 13.0379C22.025 10.9754 20.3437 9.29414 18.2812 9.29414H17.3812V8.02539C17.3812 7.59414 17.0312 7.24414 16.6 7.24414C16.1687 7.24414 15.8187 7.59414 15.8187 8.02539V9.29414H13.5875V8.02539C13.5875 7.59414 13.2375 7.24414 12.8062 7.24414C12.375 7.24414 12.025 7.59414 12.025 8.02539V9.29414H10.7562C10.325 9.29414 9.97498 9.64414 9.97498 10.0754C9.97498 10.5066 10.325 10.8566 10.7562 10.8566H12.025V16.0004V21.1441H10.7562C10.325 21.1441 9.97498 21.4941 9.97498 21.9254C9.97498 22.3566 10.325 22.7066 10.7562 22.7066H12.025V23.9754C12.025 24.4066 12.375 24.7566 12.8062 24.7566C13.2375 24.7566 13.5875 24.4066 13.5875 23.9754V22.7066H15.8187V23.9754C15.8187 24.4066 16.1687 24.7566 16.6 24.7566C17.0312 24.7566 17.3812 24.4066 17.3812 23.9754V22.7066H18.2812C20.3437 22.7066 22.025 21.0254 22.025 18.9629C22.025 17.7566 21.4562 16.6879 20.5687 16.0004ZM20.4625 13.0379C20.4625 14.2379 19.4875 15.2191 18.2812 15.2191H13.5812V10.8566H18.2812C19.4875 10.8566 20.4625 11.8379 20.4625 13.0379ZM18.2812 21.1441H13.5812V16.7816H18.2812C19.4812 16.7816 20.4625 17.7629 20.4625 18.9629C20.4625 20.1629 19.4875 21.1441 18.2812 21.1441Z",
    fill: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12237_127004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9361 5.47852C22.2587 5.47852 21.7277 6.00959 21.7277 6.68698C21.7277 7.36436 22.2587 7.89543 22.9361 7.89543C23.6135 7.89543 24.1446 7.36436 24.1446 6.68698C24.1446 6.00959 23.6135 5.47852 22.9361 5.47852ZM26.5615 6.68698C26.5615 6.00959 26.0304 5.47852 25.353 5.47852C24.6757 5.47852 24.1446 6.00959 24.1446 6.68698C24.1446 7.36436 24.6757 7.89543 25.353 7.89543C26.0304 7.89543 26.5615 7.36436 26.5615 6.68698ZM27.77 7.89543C28.4473 7.89543 28.9784 7.36436 28.9784 6.68698C28.9784 6.00959 28.4473 5.47852 27.77 5.47852C27.0926 5.47852 26.5615 6.00959 26.5615 6.68698C26.5615 7.36436 27.0926 7.89543 27.77 7.89543Z",
    fill: "#CFA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3535 0C21.6918 0 18.6667 3.02514 18.6667 6.68681C18.6667 7.84689 18.9688 8.98284 19.5488 9.96169C19.996 10.7472 19.7422 11.7503 18.9688 12.2095C18.7271 12.3424 18.6184 12.6203 18.6909 12.8862C18.7634 13.152 18.993 13.3333 19.2709 13.3333H25.3535C25.8852 13.3333 26.4049 13.2729 26.852 13.1641C29.3052 12.5962 31.2629 10.6384 31.8308 8.19738C31.9396 7.73817 32 7.23061 32 6.68681C32 3.02514 29.0152 0 25.3535 0ZM22.9366 7.29104C22.5982 7.29104 22.3323 7.02514 22.3323 6.68681C22.3323 6.3484 22.5982 6.08258 22.9366 6.08258C23.275 6.08258 23.5408 6.3484 23.5408 6.68681C23.5408 7.02514 23.275 7.29104 22.9366 7.29104ZM25.3535 7.29104C25.0151 7.29104 24.7493 7.02514 24.7493 6.68681C24.7493 6.3484 25.0151 6.08258 25.3535 6.08258C25.6919 6.08258 25.9577 6.3484 25.9577 6.68681C25.9577 7.02514 25.6919 7.29104 25.3535 7.29104ZM27.7704 7.29104C27.432 7.29104 27.1662 7.02514 27.1662 6.68681C27.1662 6.3484 27.432 6.08258 27.7704 6.08258C28.1088 6.08258 28.3746 6.3484 28.3746 6.68681C28.3746 7.02514 28.1088 7.29104 27.7704 7.29104Z",
    fill: "url(#paint2_linear_12237_127004)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12237_127004",
    x: 17.6667,
    y: 0,
    width: 14.3333,
    height: 14.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12237_127004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12237_127004",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12237_127004",
    x1: 4.6215,
    y1: 4.6215,
    x2: 27.6959,
    y2: 27.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0059793,
    stopColor: "#FFF5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4891,
    stopColor: "#FFDA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8318,
    stopColor: "#FFC925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12237_127004",
    x1: 4.76118,
    y1: 4.76099,
    x2: 25.819,
    y2: 25.8188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12237_127004",
    x1: 27.146,
    y1: 14.5418,
    x2: 27.146,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12237_127004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinFooter);
export default __webpack_public_path__ + "static/media/bitcoinFooter.a97598d5b1b0bf93c8a739e7c613baaf.svg";
export { ForwardRef as ReactComponent };